/**
* React component responsible for setting up a react-slick carousel component
*
* Copyright (c) 2020 Coursera
* Author: Kelvin Nguyen
*/
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick'
import Button from 'components/theme/Button'
import ChevronLeft from './icons/chevron-left.svg'
import ChevronRight from './icons/chevron-right.svg'
import styles from './Carousel.scss'

const arrowProps = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

const PrevArrow = ({ className, style, onClick }) => (
  <Button
    variant="tertiary"
    className={className}
    style={style}
    onClick={onClick}>
    <img src={ChevronLeft} alt="left arrow" />
  </Button>
)

const NextArrow = ({ className, style, onClick }) => (
  <Button
    variant="tertiary"
    className={className}
    style={style}
    onClick={onClick}>
    <img src={ChevronRight} alt="right arrow" />
  </Button>
)

PrevArrow.propTypes = arrowProps
NextArrow.propTypes = arrowProps

const Carousel = ({
  children,
}) => {
  const settings = useMemo(() => ({
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: styles.tablet,
        settings: {
          dots: true,
        },
      },
    ],
  }), [])

  return (
    <Slider {...settings}>
      {children}
    </Slider>
  )
}

Carousel.propTypes = {
  children: PropTypes.node,
}

export default Carousel
